import React from "react";
import TextCellInfo from "./TextCellInfo";
import { BonusDetail } from "../../interfaces/BonusDetail";

interface Props {
  bonusDetail: BonusDetail;
  dataTest: string;
  thirdColumn: boolean;
}

export default function Bonus({ bonusDetail, dataTest, thirdColumn }: Props) {
  const colorClass = bonusDetail.bonusDetailType;
  const bonusSourceNameId = `bonus-source-name-${bonusDetail.sourceKey}-${dataTest}`;

  const elements: JSX.Element[] = [];
  elements.push(
    <TextCellInfo
      key={bonusSourceNameId}
      dataTest={bonusSourceNameId}
      classes={`bonus-detail ${colorClass}`}
      text={bonusDetail.sourceName}
    />
  );
  if (thirdColumn) {
    const bonusKeyId = `bonus-key-${bonusDetail.sourceKey}-${dataTest}`;
    elements.push(
      <TextCellInfo
        key={bonusKeyId}
        dataTest={bonusKeyId}
        classes={`bonus-detail ${colorClass}`}
        text={bonusDetail.sourceKey}
      />
    );
  }
  const bonusValueId = `bonus-value-${bonusDetail.sourceKey}-${dataTest}`;
  elements.push(
    <TextCellInfo
      key={bonusValueId}
      dataTest={bonusValueId}
      classes={`bonus-detail ${colorClass}`}
      text={bonusDetail.current}
    />
  );

  return React.createElement(React.Fragment, {}, elements);
}
